// extracted by mini-css-extract-plugin
export var cardWrapper = "_56-0";